import { useSearchParams } from 'react-router-dom'
import { PageHeader } from '@/components/PageHeader'
import { PerformanceScopeBanner } from '@/components/PerformanceScopeBanner'
import { TerritoryMap } from '@/components/TerritoryMap'
import { BookingOpportunitiesPanel } from '@/components/BookingOpportunitiesPanel'
import { parseLayersParam } from './territory-map-helpers'

export function TerritoryPage() {
  const [searchParams] = useSearchParams()

  return (
    <div className="space-y-4">
      <PageHeader
        title="Territory"
        subtitle="Multi-layer map — toggle data layers, filter by tour/leg/show, or set a radius to explore nearby points."
      />
      <PerformanceScopeBanner />
      <BookingOpportunitiesPanel />
      <TerritoryMap initialLayers={parseLayersParam(searchParams.get('layers'))} />
    </div>
  )
}
